<div *ngIf="trainerEvaluation">
    <h2>{{ 'session-details.evaluations.trainerEvaluation' | translate }}</h2>
    <div class="row" *jhiHasAnyAuthority="'ROLE_ADMIN'">
        <h3 class="rating-category">
            {{ 'session-details.evaluations.overall' | translate }}
        </h3>
        <div class="col-md-6">
            <div class="rating-text">
                {{ 'session-details.evaluations.overallFeeling.label' | translate }}
            </div>
            <div class="rating-small">
                {{ 'session-details.evaluations.overallFeeling.' + trainerEvaluation.overallFeeling | translate }}
            </div>
        </div>
        <div class="col-md-6">
            <div class="rating-text">
                {{ 'session-details.evaluations.comments' | translate }}
            </div>
            <div class="rating-text">
                {{ trainerEvaluation.comments }}
            </div>
        </div>
    </div>
    <hr />
    <div class="row">
        <h3 class="rating-category">
            {{ 'session-details.evaluations.studentsAndMaterial' | translate }}
        </h3>
        <div class="col-md-4">
            <div class="rating-text">
                {{ 'session-details.evaluations.studentsHadPrerequisites.label' | translate }}
            </div>
            <div class="rating-small">
                {{ 'session-details.evaluations.studentsHadPrerequisites.' + trainerEvaluation.studentsHadPrerequisites | translate }}
            </div>
        </div>
        <div class="col-md-4">
            <div class="rating-text">
                {{ 'session-details.evaluations.slidesNeedUpdate.label' | translate }}
            </div>
            <div class="rating-small">
                {{ 'session-details.evaluations.slidesNeedUpdate.' + trainerEvaluation.slidesNeedUpdate | translate }}
            </div>
        </div>
        <div class="col-md-4">
            <div class="rating-text">
                {{ 'session-details.evaluations.workbookNeedsUpdate.label' | translate }}
            </div>
            <div class="rating-small">
                {{ 'session-details.evaluations.workbookNeedsUpdate.' + trainerEvaluation.workbookNeedsUpdate | translate }}
            </div>
        </div>
    </div>
</div>
<div id="no-trainer-evaluation" *ngIf="!trainerEvaluation">
    <h2>{{ 'session-details.evaluations.noTrainerEvaluation' | translate }}</h2>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/evaluations/trainer-evaluation.component.html